export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100% - 10px)',
        padding: "0px 15px 10px 15px",
        marginBottom: "10px"
    },
    cardContainer: {
        backgroundColor: "#FFFFFF",
        borderRadius: "20px",
        height: "100%",
        overflowY: "auto",
        padding: '20px 20px 20px 20px'
    },
    linkText: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#000000'
    },
    paraText: {
        fontSize: '14px',
        fontWeight: '400',
    }
})